import { pickBy } from '@/utils'
import AttrItem from './attr-item'

export default {
  name: 'showcase',
  setting: [
    { label: '標題', key: 'title', component: 'input', value: '標題' },
    { label: '副標題', key: 'subtitle', component: 'input', value: '副標題' },
    { label: '組件間距', key: 'padded', component: 'switch', value: true },
    // { label: '圖片描述', key: 'content', component: 'switch', value: true },
    {
      label: '顯示圖',
      key: 'data',
      component: function (h, { key }) {
        return <AttrItem v-model={this.value[key]} />
      },
      value: [
        { imgUrl: '', linkPage: '', content: '', title: '', id: '' },
        { imgUrl: '', linkPage: '', content: '', title: '', id: '' },
        { imgUrl: '', linkPage: '', content: '', title: '', id: '' }
      ],
      tip: `建議尺寸:</br>大圖（175px * 310px）小圖（175px * 150px）`
    }
  ],
  transformIn: (v) => {
    const { name, base, config, data } = v
    return {
      name,
      ...base,
      ...config,
      data
    }
  },
  transformOut: (v) => {
    return pickBy(v, {
      name: 'name',
      base: (v) => {
        return pickBy(v, {
          title: 'title',
          subtitle: 'subtitle',
          padded: 'padded'
        })
      },
      config: () => {
        return {
          style: 1
        }
      },
      data: 'data'
    })
  }
}
